export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative pt-16 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="relative w-full px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 max-w-6xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              实时追踪 · 深扒真相
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 font-heading leading-tight mb-3">
              每日大瓜
              <span className="block text-primary-500">全网黑料深扒第一站</span>
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-heading mb-5">
              不放过每一个瓜，不错过每一段黑历史
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              每日大瓜是国内领先的娱乐八卦与黑料深扒平台，聚焦娱乐圈、网红圈、直播圈的最新动态。我们以独立视角追踪明星黑历史、圈内揭底与独家猛料，每日持续更新，为吃瓜群众提供最全、最快、最深的黑料合集。当前专题覆盖近期热门塌房事件与跨圈连环瓜，一站吃透全网热点。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-500 font-heading">50+</div>
                <div className="text-xs text-foreground-500">日更爆料</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-500 font-heading">200+</div>
                <div className="text-xs text-foreground-500">收录艺人</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-500 font-heading">10万+</div>
                <div className="text-xs text-foreground-500">瓜友社区</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleClick('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-sparkling-line"></i>
                开始吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => { e.preventDefault(); handleClick('#contact'); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-primary-300 text-primary-600 font-semibold rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line"></i>
                我要爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20artistic%20abstract%20composition%20with%20warm%20crimson%20and%20gold%20tones%20mysterious%20atmosphere%20stylized%20spotlight%20effect%20on%20dark%20textured%20background%20conceptual%20representation%20of%20entertainment%20gossip%20and%20revelation%20editorial%20illustration%20style%20with%20bold%20graphic%20elements%20cinematic%20mood%20lighting%20no%20text%20high%20contrast%20sophisticated%20modern%20art%20aesthetic&width=1200&height=900&seq=hero-melon-2026&orientation=landscape"
                alt="每日大瓜 - 全网黑料深扒第一站"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}